/**
 * Why a payin/instruction landed in NEEDS_REVIEW. Two genuinely different causes
 * end up in the same status: the instruction may be perfectly identified but
 * currently ineligible to receive funds (wrong status), or the instruction may
 * be eligible but the reference-code match itself is uncertain (recovered by
 * guessing, not read cleanly off the narrative).
 */
export enum NeedsReviewReason {
  /** The instruction was identified with full confidence, but its current status
   * (REJECTED, FAILED, CANCELLED, COMPLETED, etc.) means it shouldn't receive
   * an allocation right now. */
  INSTRUCTION_NOT_ALLOCATABLE = 'instruction_not_allocatable',
  /** The instruction is eligible, but the reference code was recovered via a
   * fallback that required dropping/guessing characters (e.g. partial anagram
   * recovery) — identification confidence is too low to auto-settle. */
  LOW_CONFIDENCE_MATCH = 'low_confidence_match',
  /** The credit carried no usable reference code; an AI matcher proposed the instruction.
   * Never auto-settled — ops must approve or reject. */
  AI_SUGGESTED_MATCH = 'ai_suggested_match'
}
